// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  'Campaign progress job is running in background':
    'Cert.Campaignprogressjobisrunninginbackground.label',
  'Progress is being updated': 'Cert.Progressisbeingupdated.label',
  'Open menu': 'certs.open.menu',
  'Click to open side panel': 'certs.click.open.side.panel',
  More: 'CERTS_BULK_MORE',
  'All Actions': 'certs.all.actions',
  'The operation is taking longer than usual. Processing your request in the background.':
    'Certs.bulkAction.info',
  'Reassignment for this certification is in progress.':
    'SyncInProgress.Default.label',
};
